/** Member profile privacy preferences (public by default, toggles for discoverability/activity). */
export type PrivacyPrefs = {
  isDiscoverable: boolean;
  showFollowers: boolean;
  showFollowing: boolean;
  showActivity: boolean;
  showBookmarks: boolean;
  allowMessagesFrom: 'everyone' | 'followers' | 'none';
};

export const DEFAULT_PRIVACY_PREFS: PrivacyPrefs = {
  isDiscoverable: true,
  showFollowers: true,
  showFollowing: true,
  showActivity: true,
  showBookmarks: false,
  allowMessagesFrom: 'everyone',
};

export type ContentPrefs = {
  mutedWords: string[];
  /** When false, profile Articles tab is hidden from visitors (owner still sees it). */
  showArticlesTab: boolean;
  /** Default comment policy applied to new article drafts. */
  defaultArticleComments: 'everyone' | 'off';
  /** Client preference: warn when publishing an article without a cover image. */
  warnArticleCoverMissing: boolean;
};

export const DEFAULT_CONTENT_PREFS: ContentPrefs = {
  mutedWords: [],
  showArticlesTab: true,
  defaultArticleComments: 'everyone',
  warnArticleCoverMissing: true,
};

export type { NotificationPrefsLegacy as NotificationPrefs } from '../notifications/notification-prefs';
export type { NotificationPrefsV2 } from '../notifications/notification-channels';

export {
  DEFAULT_NOTIFICATION_PREFS_LEGACY as DEFAULT_NOTIFICATION_PREFS,
  DEFAULT_NOTIFICATION_PREFS_V2,
  buildNotificationPrefsV2,
  parseNotificationPrefs,
  parseNotificationPrefsLegacy,
  isInAppEnabled,
  emailModeForType,
  categoryForNotificationType,
} from '../notifications/notification-prefs';

export type SocialPlatform =
  | 'website'
  | 'x'
  | 'facebook'
  | 'github'
  | 'linkedin'
  | 'youtube'
  | 'instagram'
  | 'tiktok'
  | 'snapchat'
  | 'substack'
  | 'reddit'
  | 'whatsapp'
  | 'discord'
  | 'pinterest'
  | 'twitch'
  | 'vimeo'
  | 'newsletter'
  | 'portfolio'
  | 'other';

export type SocialLink = {
  id?: string;
  label: string;
  url: string;
  platform?: SocialPlatform | null;
  sortOrder?: number;
};

export type ProfilePrompts = {
  workingOn?: string | null;
  learning?: string | null;
  askMeAbout?: string | null;
};

export const EMPTY_PROFILE_PROMPTS: ProfilePrompts = {
  workingOn: null,
  learning: null,
  askMeAbout: null,
};

export type ProfileCompletionItem =
  | 'email_verified'
  | 'username'
  | 'display_name'
  | 'avatar'
  | 'banner'
  | 'bio'
  | 'interests'
  | 'privacy_reviewed'
  | 'social_links'
  | 'two_factor';

export type ProfileCompletionState = {
  score: number;
  completed: ProfileCompletionItem[];
  pending: ProfileCompletionItem[];
};

export type WelcomeWizardStatus = 'not_started' | 'dismissed' | 'completed';

export type WelcomeWizardState = {
  status: WelcomeWizardStatus;
  resumeSnoozedAt: string | null;
};
